import React, { Component } from 'react'
import PropTypes from 'prop-types'
import arraySort from 'array-sort'
import { injectIntl } from 'react-intl'
import Select from 'react-select'

import KeywordSearch from '../mini/SearchInputs/KeywordSearch'
import SearchArea from '../mini/SearchArea'
import WrappedSearchFilter from '../HOC/WrappedSearchFilter'
import CourseSelect from '../mini/CourseSelect'

import { messages as labels } from '../../utils/messages/label'
import { messages as placeholders } from '../../utils/messages/placeholder'
import {
  setKeywordFilter,
  setNeedStandardsFilter,
  setNeedFinalFilter,
  setAllReviewsFilter,
  setAuthorsFilter,
  setCourseFilter,
  setLevelFilter as setLevelFilterAction,
  setTargetGradeLevelFilter
} from '../../actions/reviewqueuefilters'
import { fetchReviewQueue } from '../../actions/reviewqueue'
import { mapLevels } from '../../utils/levels'

class SearchFilters extends Component {
  constructor (props) {
    super(props)
    this.state = {
      keywordSearched: false
    }
    this.onSearchClickBound = this.onSearchClick.bind(this)
    this.onKeywordKeyPressBound = this.onKeywordKeyPress.bind(this)
    this.onKeywordFilterChangeBound = this.onKeywordFilterChange.bind(this)
    this.onKeywordSearchClickBound = this.onKeywordSearchClick.bind(this)
    this.onClearKeywordSearchClickBound =
      this.onClearKeywordSearchClick.bind(this)
    this.onStandardsFilterClickBound = this.onStandardsFilterClick.bind(this)
    this.onFinalFilterClickBound = this.onFinalFilterClick.bind(this)
    this.onAllReviewsClickBound = this.onAllReviewsClick.bind(this)
    this.onSetCourseFilterBound = this.onSetCourseFilter.bind(this)
    this.setLevelFilterBound = this.setLevelFilter.bind(this)
    this.keywordSearchInput = React.createRef()
    this.courseFilterRef = React.createRef()
    this.levelFilterRef = React.createRef()
  }

  render () {
    const {
      qdUsers,
      dispatch,
      intl,
      keywordFilter,
      needFinalCount,
      needStandardsCount,
      totalCount,
      needStandardsReview,
      needFinalReview,
      authorsFilter,
      courseFilter,
      courses,
      levels,
      gradeLevels,
      gradeFilters,
      isFetchingGrades
    } = this.props
    const intlMessages = {
      authorLabel: intl.formatMessage(labels.author),
      authorPlaceholder: intl.formatMessage(placeholders.selectAuthors),
      titlePlaceholder: intl.formatMessage(placeholders.enterTitle),
      targetGradeLevel: intl.formatMessage(labels.targetGradeLevel),
      selectGrades: intl.formatMessage(placeholders.selectGrades)
    }

    return (
      <div
        className="search-filters quests-search"
        style={{ paddingTop: '30px' }}
      >
        <KeywordSearch
          keywordFilter={keywordFilter}
          keywordSearchRef={this.keywordSearchInput}
          onKeywordKeyPress={this.onKeywordKeyPressBound}
          onKeywordFilterChange={this.onKeywordFilterChangeBound}
          keywordSearched={this.state.keywordSearched}
          onClearKeywordSearchClick={this.onClearKeywordSearchClickBound}
          onKeywordSearchClick={this.onKeywordSearchClickBound}
        />

        <div className="caption1" style={{ marginBottom: '24px' }}>
          Filter by
        </div>

        <div className="radio-wrapper">
          <input
            type="radio"
            id="all-reviews"
            checked={!needStandardsReview && !needFinalReview}
            onClick={this.onAllReviewsClickBound}
          />
          <label
            htmlFor="all-reviews"
            className={`h5 ${
              !needStandardsReview && !needFinalReview ? 'active' : ''
            }`}
          >
            {`All Reviews (${totalCount})`}
          </label>
        </div>

        <div className="radio-wrapper">
          <input
            type="radio"
            id="need-standards-review"
            checked={needStandardsReview && !needFinalReview}
            onClick={this.onStandardsFilterClickBound}
          />
          <label
            htmlFor="need-standards-review"
            className={`h5 ${
              needStandardsReview && !needFinalReview ? 'active' : ''
            }`}
          >
            {`Need Standards Review (${needStandardsCount})`}
          </label>
        </div>

        <div className="radio-wrapper">
          <input
            type="radio"
            id="need-final-review"
            checked={!needStandardsReview && needFinalReview}
            onClick={this.onFinalFilterClickBound}
          />
          <label
            htmlFor="need-final-review"
            className={`h5 ${
              !needStandardsReview && needFinalReview ? 'active' : ''
            }`}
          >
            {`Need Final Review (${needFinalCount})`}
          </label>
        </div>

        <div className="horizontal-divider" />

        <div className="area inputs-wrapper">
          <SearchArea
            dispatch={dispatch}
            label={intlMessages.authorLabel}
            area="author"
            placeholder={intlMessages.authorPlaceholder}
            options={arraySort(this.mapList(qdUsers), ['sort'])}
            values={authorsFilter}
            headerClass="h5"
            filterAction={setAuthorsFilter}
            fetchAction={fetchReviewQueue}
          />

          <SearchArea
            headerClass="h5"
            dispatch={dispatch}
            label={intlMessages.targetGradeLevel}
            area="grades"
            placeholder={intlMessages.selectGrades}
            values={gradeFilters}
            options={arraySort(this.mapList(gradeLevels), ['sort'])}
            filterAction={setTargetGradeLevelFilter}
            loading={isFetchingGrades}
            fetchAction={fetchReviewQueue}
          />

          {courses.length > 0 && (
            <WrappedSearchFilter
              area="courses"
              active={Boolean(courseFilter)}
              label="Intended Journey"
              wrappedRef={this.courseFilterRef}
            >
              <CourseSelect
                courseFilterRef={this.courseFilterRef}
                course={courseFilter ? courseFilter : null}
                courses={courses}
                onCourseChange={this.onSetCourseFilterBound}
                labelTruncationLength={99999}
                placeholder="Select journey"
              />
            </WrappedSearchFilter>
          )}
          {courseFilter && (
            <WrappedSearchFilter
              area="levels"
              active={this.props.levelFilters.length > 0}
              disabled={levels.length === 0}
              disabledText="No levels are available for this journey."
              label="Intended Level"
              wrappedRef={this.levelFilterRef}
            >
              <Select
                multi
                ref={this.levelFilterRef}
                searchable
                options={mapLevels(levels, 22)}
                value={this.props.levelFilters}
                onChange={this.setLevelFilterBound}
                placeholder="Select level"
                matchProp="label"
              />
            </WrappedSearchFilter>
          )}
        </div>
      </div>
    )
  }

  mapList(arr) {
    return arr.map(function (el) {
      return {
        value: el.id,
        label: el.name,
        sort: el.sort ? el.sort : el.name.trim().toLowerCase()
      }
    })
  }

  onKeywordFilterChange(e) {
    this.props.dispatch(setKeywordFilter(e.currentTarget.value))
  }

  onKeywordSearchClick() {
    this.setState(() => {
      return {
        keywordSearched: true
      }
    })
    this.onSearchClickBound()
  }

  onKeywordKeyPress (e) {
    if (
      this.props.keywordFilter.length > 0 &&
      (e.which === 13 || e.charCode === 13)
    ) {
      this.onKeywordSearchClickBound()
      this.keywordSearchInput.current.blur()
    }
  }

  onClearKeywordSearchClick () {
    this.props.dispatch(setKeywordFilter(''))
    this.setState(() => {
      return {
        keywordSearched: false
      }
    })
    this.onSearchClickBound()
  }

  onSearchClick () {
    this.props.dispatch(fetchReviewQueue(1, true))
  }

  async onStandardsFilterClick () {
    await this.props.dispatch(setNeedStandardsFilter())
    this.onSearchClick()
  }

  async onFinalFilterClick () {
    await this.props.dispatch(setNeedFinalFilter())
    this.onSearchClick()
  }

  async onAllReviewsClick () {
    await this.props.dispatch(setAllReviewsFilter())
    this.onSearchClick()
  }

  async onSetCourseFilter (e) {
    await this.props.dispatch(setCourseFilter(e ? e : null))
    this.onSearchClickBound()
  }

  async setLevelFilter (event) {
    this.props.dispatch(
      setLevelFilterAction(
        event.map(function (e) {
          return e.value
        })
      )
    )
    this.props.dispatch(this.onSearchClickBound)
  }
}

SearchFilters.propTypes = {
  qdUsers: PropTypes.array,
  dispatch: PropTypes.func,
  intl: PropTypes.object,
  keywordFilter: PropTypes.string,
  authorsFilter: PropTypes.array,
  needStandardsCount: PropTypes.number,
  needFinalCount: PropTypes.number,
  totalCount: PropTypes.number,
  needStandardsReview: PropTypes.bool.isRequired,
  needFinalReview: PropTypes.bool.isRequired,
  quests: PropTypes.array,
  courses: PropTypes.array,
  courseFilter: PropTypes.object,
  levelFilters: PropTypes.array,
  levels: PropTypes.array,
  gradeFilters: PropTypes.array.isRequired,
  gradeLevels: PropTypes.array.isRequired,
  isFetchingGrades: PropTypes.bool.isRequired
}

export default injectIntl(SearchFilters)



// WEBPACK FOOTER //
// ./src/components/reviewqueue/SearchFilters.js